import { AppId, Route, createPageRoute } from '@lumapps/router';

export const lumappsApplicationsRoute: Route = createPageRoute({
    slug: 'provider-settings/lumapps-applications',
    appId: AppId.backOffice,
});
